import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Suspense, lazy, useEffect } from 'react'
import { GA_ID } from '@/lib/env'

const TanStackRouterDevtools =
  import.meta.env.PROD
    ? () => null
    : lazy(() =>
        import('@tanstack/react-router-devtools').then((m) => ({
          default: m.TanStackRouterDevtools,
        })),
      )

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
})

function RootComponent() {
  useEffect(() => {
    if (!GA_ID) return
    const s1 = document.createElement('script')
    s1.async = true
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
    document.head.appendChild(s1)

    const s2 = document.createElement('script')
    s2.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_ID}');`
    document.head.appendChild(s2)
    return () => {
      s1.remove()
      s2.remove()
    }
  }, [])

  return (
    <>
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  )
}

function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="text-center space-y-2">
        <h1 className="text-3xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground">The page you were looking for doesn&apos;t exist.</p>
        <a href="/" className="text-primary underline">
          Go home
        </a>
      </div>
    </div>
  )
}
